import { IonContent, IonPage } from '@ionic/react'
import React from 'react'
import Header from '../components/Header'
import './ProductIntro.css'

const HelpCenter: React.FC = () => {
    return (
        <IonPage>
            <IonContent className='help-center-content'>
                <Header title='产品手册' />
                <iframe
                    title='产品手册'
                    className='ProductIframe'
                    src='/manual/index.html'
                />
            </IonContent>
        </IonPage>
    )
}

export default HelpCenter
